import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';

const PaymentModal = ({ isOpen, onClose, paymentMethod, qrCode }) => {
  const { t } = useLanguage();
  
  if (!isOpen || !paymentMethod) return null;

  const modalVariants = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
      transition: { duration: 0.3 }
    },
    exit: { 
      opacity: 0,
      transition: { duration: 0.2 }
    }
  };

  const contentVariants = {
    hidden: { 
      opacity: 0, 
      scale: 0.8,
      y: 50
    },
    visible: { 
      opacity: 1, 
      scale: 1,
      y: 0,
      transition: { 
        duration: 0.4,
        type: "spring",
        stiffness: 300,
        damping: 30
      }
    },
    exit: { 
      opacity: 0, 
      scale: 0.8,
      y: 50,
      transition: { duration: 0.2 }
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          variants={modalVariants}
          initial="hidden"
          animate="visible"
          exit="exit"
          className="payment-modal-overlay"
          onClick={onClose}
        >
          <motion.div
            variants={contentVariants}
            className="payment-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button 
              className="payment-modal-close"
              onClick={onClose}
              aria-label="Close modal"
            >
              <i className="fas fa-times"></i>
            </button>

            {/* Modal Header */}
            <div className="payment-modal-header">
              <div className="payment-modal-icon">
                <i className={paymentMethod.icon}></i>
              </div>
              <h3 className="payment-modal-title">{paymentMethod.name}</h3>
              <p className="payment-modal-description">{paymentMethod.description}</p>
            </div>

            {/* Modal Body */}
            <div className="payment-modal-body">
              {/* QR Code Section */}
              {qrCode && (
                <div className="payment-modal-qr-section">
                  <div className="payment-modal-qr-container">
                    <img 
                      src={qrCode} 
                      alt={`QR Code for ${paymentMethod.name}`}
                      className="payment-modal-qr-image"
                      onClick={() => {
                        if (paymentMethod.link) {
                          window.open(paymentMethod.link, '_blank');
                        }
                      }}
                    />
                  </div>
                  {(paymentMethod.link || paymentMethod.name === 'Zelle') && (
                    <p className="payment-modal-qr-note">
                        {t('gifts.modal.scanToPay')}
                    </p>
                  )}
                </div>
              )}

              {/* Payment Details */}
              <div className="payment-modal-details">
                <h4 className="payment-modal-details-title">{t('gifts.modal.paymentDetails')}</h4>
                <div className="payment-modal-details-content">
                  <p className="payment-modal-details-text">
                    {paymentMethod.details}
                  </p>
                  
                </div>
              </div>
            </div>

            {/* Modal Footer */}
            <div className="payment-modal-footer">
              <button 
                className="payment-modal-close-btn"
                onClick={onClose}
              >
{t('gifts.modal.close')}
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PaymentModal;
